import React, { useEffect } from "react";
import { QRCodeSVG } from "qrcode.react";
import { logEvent } from "../../actions";

const SMS_DEEP_LINK =
  "sms:+12135584348?&body=Hi - I completed my Manatee screener at my physician's office and I am interested in getting started with care.";

export default function QrCode() {
  useEffect(() => {
    logEvent("qr_shown");
  }, []);

  return (
    <div className="screener-qr">
      <p className="screener-qr__title">OR SCAN NOW</p>
      <div className="screener-qr__frame">
        <QRCodeSVG
          className="screener-qr__image"
          value={SMS_DEEP_LINK}
          size={160}
          level="M"
          bgColor="#ffffff"
          fgColor="#3b5bdb"
          role="img"
          aria-label="QR code that opens a text message to Manatee"
        />
      </div>
      <p className="screener-qr__caption">Opens a text to Manatee — just hit send.</p>
    </div>
  );
}
